import ninjaApi from 'store/redux/apis/ninja.api';

/**
 * Shopify connection api
 */
export const shopifyApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['Shopify', 'Integrations'],
  endpoints: (build) => ({
    requestShopifyAuthorization: build.mutation({
      query: (data) => ({
        url: '/shopify/integrate',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Shopify', 'Integrations'],
    }),

    shopifyWidgets: build.query({
      query: (data) => ({
        url: '/dashboard/widgets/shopify',
        method: 'POST',
        data: data,
      }),
    }),
  }),
});

export const { useRequestShopifyAuthorizationMutation, useShopifyWidgetsQuery } = shopifyApi;
